/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneColumns from 'base/components/standalone/Columns';

export const DynamicStandaloneColumns = StandaloneColumns;
export type DynamicStandaloneColumnsProps = PropsFromComponent<typeof StandaloneColumns>;

export const DynamicStandaloneColumnsWith = (extras: DynamicStandaloneExtras): typeof StandaloneColumns => {
    return function DynamicStandaloneColumns(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Columns');
        return <StandaloneColumns {...mergeProps({ options: { theme } }, props)} />;
    }
}